import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-employee-documents',
  templateUrl: './employee-documents.component.html',
  styleUrls: ['./employee-documents.component.less']
})
export class EmployeeDocumentsComponent {
}
